import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Heart, Smile, Sparkles, Wind, Cloud } from 'lucide-react';

const services = [
  {
    title: "Dental Implants",
    icon: Heart,
    href: "/dental-implants",
    description: "Permanent tooth replacement solutions"
  },
  {
    title: "Fixed New Teeth",
    icon: Smile,
    href: "/fixed-new-teeth",
    description: "All-on-4® & All-on-6® restoration"
  },
  {
    title: "Cosmetic Dentistry",
    icon: Sparkles,
    href: "/cosmetic-dentistry",
    description: "Smile transformation & enhancement"
  },
  {
    title: "Invisalign",
    icon: Wind,
    href: "/invisalign",
    description: "Clear aligner orthodontics"
  },
  {
    title: "Sedation Dentistry",
    icon: Cloud,
    href: "/sedation-dentistry",
    description: "Comfortable care for anxious patients"
  }
];

export default function ServicesBanner() {
  return (
    <section className="py-16 bg-gradient-to-r from-amber-50 via-white to-amber-50/50 border-y border-amber-100">
      <div className="container mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6"
        >
          {services.map((service, index) => {
            const IconComponent = service.icon;
            return (
              <motion.div
                key={service.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <Link
                  to={service.href}
                  className="group h-full block"
                >
                  <div className="h-full bg-white rounded-2xl p-4 md:p-6 border border-amber-100 hover:border-amber-400 hover:shadow-lg transition-all duration-300">
                    <div className="w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-amber-600 transition-colors duration-300">
                      <IconComponent className="w-6 h-6 text-amber-600 group-hover:text-white transition-colors duration-300" />
                    </div>
                    <h3 className="text-lg font-medium text-slate-800 mb-2 group-hover:text-amber-700 transition-colors">
                      {service.title}
                    </h3>
                    <p className="text-sm text-slate-600 group-hover:text-slate-700 transition-colors">
                      {service.description}
                    </p>
                    <div className="mt-4 flex items-center text-amber-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <span className="text-sm font-medium">Learn more →</span>
                    </div>
                  </div>
                </Link>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}